import { Link, Navigate, useParams } from 'react-router-dom';
import { Card } from '../components/ui';
import type { Kachel } from '../types';
import { KACHEL_INFO } from './MeinTag';

const PHASE: Record<Kachel, string> = {
  bestellung: '',
  service: '',
  lieferung: '',
};

/** Platzhalter, bis der Bereich gebaut ist. */
export function KachelPage() {
  const art = (useParams().art ?? 'bestellung') as Kachel;
  const info = KACHEL_INFO[art] ?? KACHEL_INFO.bestellung;
  if (!PHASE[art]) return <Navigate to={info.pfad} replace />;
  return (
    <>
      <div className="kopf">
        <h1>
          {info.symbol} {info.titel}
        </h1>
      </div>
      <Card>
        <p style={{ marginTop: 0 }}>Dieser Bereich wird gerade gebaut: {PHASE[art]}.</p>
        <p className="muted">
          Bis dahin lässt sich alles, was nicht vergessen werden darf, als <Link to="/tickets">Ticket</Link> mit Zuständigem und
          Frist festhalten.
        </p>
      </Card>
    </>
  );
}
